<ng-container *ngIf="!isKpiData; else kpiBlock">
  <div class="chart-header">
    <h2 class="chart-title">{{ chartTitle }}</h2>
    <ng-container *ngIf="expandedView">
      <button (click)="onExpandButtonClick()" class="chart-expanded-view-button">
        <mat-icon svgIcon="enlarge" class="chart-expanded-view-icon"></mat-icon>
      </button>
    </ng-container>
  </div>
  <ng-container *ngIf="render">
    <div
      echarts
      (chartInit)="onChartInit($event)"
      (chartClick)="onChartClick(field, $event)"
      [initOpts]="initOption"
      [options]="chartOption"
      [autoResize]="true"
      class="chart-echart"
    ></div>
  </ng-container>
</ng-container>
<ng-template #kpiBlock>
  <div *ngIf="getSortedDataKeysLength() > 0; else noDataTemplate">
    <div
      echarts
      (chartInit)="onChartInit($event)"
      (chartClick)="onChartClick(field, $event)"
      [initOpts]="initOption"
      [options]="chartOption"
      [autoResize]="true"
      [ngClass]="{
        'chart-echart': !isKpiData,
        'chart-small-chart-container': isKpiData && kpiChartSize === 'small',
        'chart-medium-chart-container-with-toggle':
          isKpiData && kpiChartSize === 'medium' && includeToggleInHeightCalculation,
        'chart-medium-chart-container': isKpiData && kpiChartSize === 'medium',
        'chart-large-chart-container': isKpiData && kpiChartSize === 'large'
      }"
      [style.height.px]="
        isKpiData && kpiChartSize === 'large' && this.chartKeys.length > 30
          ? Math.max(500, this.chartKeys.length * 30)
          : null
      "
    ></div>
  </div>
</ng-template>
<ng-template #noDataTemplate>
  <drilldown-chart-no-data-available [size]="kpiChartSize"></drilldown-chart-no-data-available>
</ng-template>
